import { useEffect, useState } from 'react';
import { Button, Container, Divider, Grid, Paper, Stack, Typography, Box } from '@mui/material';
import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, SelectTag } from '../../../../../../src/components';
import { isToday, request, toast } from '../../../../../../src/utils';
import SearchIcon from '@mui/icons-material/Search';
import { dateFormatter } from '../../../../../../src/utils';

function formatDate(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

const DETAIL_HEADER = [
  {
    header: 'Location',
    accessor: (row) => row?.location
  },
  {
    header: 'Nursing Station',
    accessor: (row) => row?.nursingstation?.name // Accessing the nested name inside nursingstation
  },
  {
    header: 'Dep. Unit',
    accessor: (row) => row?.departmentunit?.name // Accessing the nested name inside departmentunit
  },
  {
    header: 'Floor',
    accessor: (row) => row?.floor?.name // Accessing the nested name inside floor
  },
  {
    header: 'Ward',
    accessor: (row) => row?.wards?.name // Accessing the nested name inside wards
  },
  {
    header: 'Room No.',
    accessor: 'room_no' // Directly accessing room_no from row
  },
  {
    header: 'Bed No.',
    accessor: (row) => row?.bed_no // Directly accessing the bed_no
  },
  {
    header: 'Occupy Status',
    accessor: (row) => row?.occupy_status // Directly accessing the occupy_status
  },
  {
    header: 'Bed Status Percentage',
    accessor: (row) => row?.percentageWithBStatus === 0 ? "0%" : `${row?.percentageWithBStatus}%`
  },
];

const initialIndoorStatusDataObj = {
  data: [],
  loading: false
};

export const BedOccupyPercentageStatus = () => {
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);

  const methods = useForm({
    defaultValues: {},
    mode: 'all'
  });
  const { handleSubmit, setValue, reset, watch } = methods;

  const searchIPDDetails = async () => {
    setLoading(true);
    const response = await request('/bed-status-percent-list', {
      method: 'GET',
    });
    if (response?.success) {
      if (!response?.data || response.data.length === 0) {
        toast('No IPD found', { variant: 'warning' });
      } else {
        setDetailList(response?.data);
      }
    } else {
      toast('Failed to load patient details', { variant: 'error' });
    }
    setLoading(false);
  };

  useEffect(() => {
    searchIPDDetails();
  }, [methods.watch('from_date'), methods.watch('to_date')]);

  const renderTableRows = (data) => {
    // Flattening the data to generate rows for each bed
    return data.flatMap((row) => {
      return row?.beds?.map((bed) => ({
        location: row?.location,
        nursingstation: row?.nursingstation,  // Accessing full object for nursingstation
        departmentunit: row?.departmentunit,  // Accessing full object for departmentunit
        floor: row?.floor,  // Accessing full object for floor
        wards: row?.wards,  // Accessing full object for wards
        room_no: row?.room_no,
        bed_no: bed?.bed_no,  // Now included in the flattened rows
        occupy_status: bed?.occupy_status,  // Now included in the flattened rows
        percentageWithBStatus: bed?.percentageWithBStatus // Now included in the flattened rows
      }));
    });
  };
console.log(detailList,"DETAILLIST")
  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          boxSizing: 'border-box'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: '100vw',
            boxSizing: 'border-box',
            minWidth: '100%'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Bed Occupy Percentage Status
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Table
                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                    data={renderTableRows(detailList)}  // Using the flattened rows
                    columns={DETAIL_HEADER}
                    size="small"
                  />
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
